import { z } from 'zod';
import { hasAtMostDecimalPlaces } from '../promotion-credit/has-at-most-decimal-places.js';
/** `pick_item.qty` and the ledger are numeric(28,9). */
const QTY_DECIMALS = 9;
/** The smallest qty the numeric(28,9) column stores as non-zero. */
const MIN_STORABLE_QTY = 0.000000001;
/** A positive pick qty the numeric(28,9) column stores exactly. */
export function pickQtySchema(missingMessage) {
    return z
        .number({ error: missingMessage })
        .positive({ abort: true, error: 'Enter a quantity greater than 0.' })
        .min(MIN_STORABLE_QTY, 'Enter a quantity of at least 0.000000001.')
        .max(1_000_000_000, 'Enter a quantity of 1,000,000,000 or less.')
        .refine((qty) => hasAtMostDecimalPlaces(qty, QTY_DECIMALS), {
        error: `Enter a quantity with at most ${QTY_DECIMALS} decimal places.`,
    });
}
//# sourceMappingURL=pick-qty-schema.js.map